import React, { useEffect } from 'react'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { useStyles } from './styles'
import pipe from 'lodash/fp/pipe'
import { get } from 'lodash'
import uniqBy from 'lodash/fp/uniqBy'
import sortBy from 'lodash/fp/sortBy'

export default ({
  selectedFacility,
  setSelectedFacility,
  locations,
  groupEventsLocations = [],
  setHasOneLocation = () => {},
}) => {
  const classes = useStyles()
  const allLocations = locations.concat(groupEventsLocations)

  const uniqueSortedLocations = pipe(uniqBy('id'), sortBy('name'))(allLocations)

  uniqueSortedLocations.unshift({
    id: 'all',
    name: `All Locations (${uniqueSortedLocations.length})`,
  })

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setSelectedFacility(get(uniqueSortedLocations, '0.id', null))
    setHasOneLocation(uniqueSortedLocations.length === 2)
  }, [locations])

  return (
    <FormControl variant="outlined" style={{ maxWidth: '200px' }}>
      <Select
        value={selectedFacility}
        variant="outlined"
        className={classes.dropdown}
        IconComponent={KeyboardArrowDownIcon}
        MenuProps={{
          className: classes.dropdown,
        }}
        onChange={e => setSelectedFacility(e.target.value)}
        InputLabelProps={{ shrink: true }}
        label="Location"
      >
        {uniqueSortedLocations.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
